import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { EditComponent } from '@app/common/templates/edit/edit.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	templateUrl: '../../../../../common/templates/edit/edit.component.html',
	styleUrls: ['../../style.scss', '../../../../../common/templates/edit/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class VehicleProcessScheduleEditComponent extends EditComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
		public config: DynamicDialogConfig,
		public ref: DynamicDialogRef
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, dialogService, globals, messageService, router, translate);

		this.apiUrl = 'TblFahrzeugAbwicklungEreignisse';
		//this.name = 'MENU.ANREDE';
		//this.url = '/' + PATH.ANREDE;
		
		if( this.config.data && this.config.data['entryData'])
			this.entry = this.config.data['entryData'];

		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ereigniszeitpunkt_string_german', required: false, width: 400 },
				{ type: 'text', key: 'FREMD_mitarbeiter_bezeichnung', required: false, width: 400 },
				{ type: 'text', key: 'erfasst_string_german', required: false, width: 400 },
				{ type: 'text', key: 'bemerkungen', required: false, width: 400 },
			]
		);
		//this.breadcrumbService.setItems([
		//	{ label: 'MENU.STAMMDATEN' },
		//	{ label: this.name, routerLink: [this.url] },
		//	{ label: 'BREADCRUMBS.DETAIL', routerLink: [this.url + '/' + PATH.DETAIL + '/' + this.id] }
		//]);
	}

	editEntry(): void {
		if (this.checkRequiredFields()) {
			this.loading += 1;
			this.fieldgroups.forEach(fg => {
				fg.forEach(field => {
					if (field.type == 'list') {
						let listString = '';
						if (this.entry[field.key]) {
							this.entry[field.key].forEach(element => {
								listString += element + ',';
							});
						}
						this.entry[field.key] = listString.slice(0, -1);
					}
				});
			});
			this.crudService.editEntry(this.apiUrl, this.entry).then(res => {
				this.messageService.add({ severity: 'success', summary: this.translate.instant('MESSAGES.SUCCESSFUL'), detail: this.translate.instant('MESSAGES.SAVED'), life: 3000 });
				this.ref.close(true);
			}).catch(err => {
				err.error.forEach(e => {
					this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
				})
			}).finally(() => {
				this.loading -= 1;
			});
		}
	}

	/**
	 * Holt den aktuellen Eintrag aus der Datenbank
	 */
	getEntry(): void {
		// gibts nicht
	}
}
